import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NavbarAddMoneyModalComponent } from './navbar-add-money-modal.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [NavbarAddMoneyModalComponent]
})
export class AddMoneyModule {}
